module.exports = __webpack_public_path__ + "img/3.8e7a59af.svg";